import React from "react";
import SkeletonC from "./SkeletonC";

{/* <SkeletonC skeletonProps={{ count : 3, height: 200,  width:200 }} ></SkeletonC> */}

const SkeletonApartmentListItemSquare = () => {
    return (

        <div className="col-lg-6 apartment-list-item-square">
            <div className="inner">
                <div className="inner-up">
                <SkeletonC skeletonThemeProps={{ height: "100%" }} skeletonProps={{ height: 410,  width:"100vw" }} />
                </div>
                <div className="inner-down">
                    <div className="features-1">
                        <div className="container">
                        <div className="row">
                            <div className="col-4 single-feature">
                                <div className="box-feature no-shadow apartment-data" style={{ height : 107 }}><SkeletonC skeletonProps={{ count : 2, height: 25,  width:100 }} /></div>
                            </div>
                            <div className="col-4 single-feature">
                                <div className="box-feature no-shadow apartment-data" style={{ height : 107 }}><SkeletonC skeletonProps={{ count : 2, height: 25,  width:100 }} /></div>
                            </div>
                            <div className="col-4 single-feature">
                                <div className="box-feature no-shadow apartment-data" style={{ height : 107 }}><SkeletonC skeletonProps={{ count : 2, height: 25,  width:100 }} /></div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SkeletonApartmentListItemSquare;